import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { EventStatsItem } from '../pages/event/EventContent';

interface EventSummaryTableProps {
  eventStats: { [date: string]: { [eventId: string]: EventStatsItem } };
  selectedEventId: string;
}

export const EventSummaryTable = ({ eventStats, selectedEventId }: EventSummaryTableProps) => {
  const timestampStringToLocalDate = (timestampStr: string): string => {
    try {
      const secondsMatch = timestampStr.match(/seconds=(\d+)/);
      const nanosecondsMatch = timestampStr.match(/nanoseconds=(\d+)/);
      
      if (!secondsMatch || !nanosecondsMatch) {
        return 'Invalid Date';
      }
      
      const seconds = parseInt(secondsMatch[1]);
      const nanoseconds = parseInt(nanosecondsMatch[1]);
      const date = new Date(seconds * 1000 + nanoseconds / 1000000);
      
      return date.toLocaleDateString('ko-KR');
    } catch (error) {
      console.error('Error parsing timestamp:', error);
      return 'Invalid Date';
    }
  }

  return (
    <Box sx={{ flex: 1 }}>
      <TableContainer sx={{ maxHeight: 300, overflow: 'auto' }}>
        <Table stickyHeader size="small">
          <TableHead>
            <TableRow>
              <TableCell>신청일</TableCell>
              <TableCell>이벤트 ID</TableCell>
              <TableCell>이벤트 시작일</TableCell>
              <TableCell>이벤트 종료일</TableCell>
              <TableCell>인원</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.entries(eventStats)
              .sort(([dateA], [dateB]) => dateB.localeCompare(dateA))
              .map(([date, events]) => (
                Object.entries(events)
                  .filter(([eventId]) => selectedEventId === 'all' || eventId === selectedEventId)
                  .map(([eventId, data]) => (
                    <TableRow key={`${date}-${eventId}`}>
                      <TableCell>{timestampStringToLocalDate(date)}</TableCell>
                      <TableCell>{eventId}</TableCell>
                      <TableCell>{data.startDate.toDate().toLocaleDateString('ko-KR')}</TableCell>
                      <TableCell>{data.endDate.toDate().toLocaleDateString('ko-KR')}</TableCell>
                      <TableCell>{data.count}명</TableCell>
                    </TableRow>
                  ))
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}; 